export class FileDownload {
  fileName: string;
  progress: number;
}

export const CHUNK_LIMIT: number = 10;
export const ERROR_PROGRESS: number = -10;
